(function(){
  'use strict';

  if (window.customElements && window.customElements.get && window.customElements.get('quick-add')) return;

  function dispatchEventName(name, element=document, options={}){
    element.dispatchEvent(new CustomEvent(name, { bubbles: true, ...options }));
  }

  function formatMoney(cents){
    if (cents === null || cents === undefined) return '';
    if (typeof cents === 'string') cents = cents.replace(/[^0-9\-]/g, '');
    cents = Number(cents);
    if (isNaN(cents)) return '';
    const moneySettings = window.settings && window.settings.money;
    const moneyFormat = moneySettings && moneySettings.moneyFormat ? moneySettings.moneyFormat : '${{amount}}';
    const amount = (cents/100).toFixed(2);
    return moneyFormat.replace('{{amount}}', amount);
  }

  const FETCH_OPTIONS = { credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } };

  class QuickAdd extends HTMLElement {
    constructor(){
      super();
      this.atcButton = this.querySelector('[data-quick-atc]');
      this.variantSelector = this.querySelector('[data-quick-atc-variant-selector]');
      this.selectedPrice = this.querySelector('[data-price]');
      this.selectedCompareAtPrice = this.querySelector('[data-compare-at-price]');
      this.registerEventListeners();
    } 

    setPriceText(t){ if (this.selectedPrice) this.selectedPrice.textContent = formatMoney(t); }
    setCompareAtPriceText(t){ if (this.selectedCompareAtPrice) this.selectedCompareAtPrice.textContent = formatMoney(t); }
    setId(t){ if (this.atcButton) this.atcButton.dataset.atcId = t; }
    setAvailability(t){ if (this.atcButton) this.atcButton.dataset.isAvailable = t; }
    getId(){ return Number(this.atcButton && this.atcButton.dataset.atcId); }

    addToCart(){
      const items = [{ id: this.getId(), quantity: 1 }];
      fetch('/cart/add.js', { ...FETCH_OPTIONS, method: 'POST', body: JSON.stringify({ items }) })
        .then(res => res.json())
        .then(() => {
          dispatchEventName('cart:update', this.atcButton, { detail: { action: 'open-cart' } });
          dispatchEventName('cart:update', document);
          dispatchEventName('cart:quantity-updated', document);
        })
        .catch(() => {});
    }

    registerEventListeners(){
      if (this.variantSelector){
        this.variantSelector.addEventListener('change', ({ target }) => {
          const { options, selectedIndex } = target;
          const opt = options[selectedIndex];
          this.setPriceText(opt.dataset.variantPrice);
          if (opt.dataset.variantCompareAtPrice){
            if (Number(opt.dataset.variantCompareAtPrice) > 0){
              this.setCompareAtPriceText(opt.dataset.variantCompareAtPrice);
              if (this.selectedCompareAtPrice) this.selectedCompareAtPrice.style.visibility = 'visible';
            } else if (this.selectedCompareAtPrice) {
              this.selectedCompareAtPrice.style.visibility = 'hidden';
            }
          }
          this.setId(opt.dataset.variantId);
          this.setAvailability(opt.dataset.available);
        });
      }

      if (this.atcButton) this.atcButton.addEventListener('click', () => this.addToCart());
    }
  }

  if (window.customElements && window.customElements.define && !window.customElements.get('quick-add')){
    window.customElements.define('quick-add', QuickAdd);
  }

})();

// Dynamically inject quick-add into client-rendered product slides (carousels, etc.)
(function(){
  if (!window.fetch) return;

  const processed = new WeakSet();

  async function fetchProduct(handle){
    try{
      const res = await fetch(`/products/${handle}.js`, { credentials: 'same-origin' });
      if (!res.ok) return null;
      return await res.json();
    }catch(e){ return null; }
  }

  function buildQuickAddElement(product){
    const el = document.createElement('quick-add');
    const firstVariant = product.variants && product.variants.length ? product.variants[0] : null;
    const price = firstVariant ? firstVariant.price : '';
    const compare = firstVariant && firstVariant.compare_at_price ? firstVariant.compare_at_price : '';

    let optionsHtml = '';
    if (product.variants && product.variants.length > 1){
      optionsHtml = `<select class="w-full md:w-auto selector appearance-none leading-none py-[9px] md:py-[7px] border font-regular text-xxs md:text-t-body-mobile min-w-[130px] md:mr-1" data-quick-atc-variant-selector>`;
      for (const variant of product.variants){
        const selected = variant.id === firstVariant.id ? 'selected="selected"' : '';
        const compareData = variant.compare_at_price ? variant.compare_at_price : 0;
        optionsHtml += `<option data-variant-price="${variant.price}" data-variant-compare-at-price="${compareData}" data-variant-id="${variant.id}" data-available="${variant.available}" ${selected}>${variant.title}</option>`;
      }
      optionsHtml += `</select>`;
    }

    el.innerHTML = `
      <div class="w-full flex mb-2 justify-between items-end xl:items-center flex-wrap md:px-1 lg:px-2 xl:px-3.5">
        <div class="selector-wrapper w-full md:w-auto flex items-start flex-col lg:flex-row lg:items-center lg:mb-0.5">
          <p class="product-card__price min-w-[60px] font-regular lg:mr-1 mb-[2px] md:mb-1 lg:mb-0 text-xxs md:text-t-body-mobile">
            <span data-price>${price}</span>
            ${ compare ? `<span class="line-through text-brand-red" data-compare-at-price>${compare}</span>` : '' }
          </p>
          ${optionsHtml}
        </div>

        <button class="quick-add-button font-regular text-xxs md:text-t-body-mobile uppercase flex items-center pt-[8px] md:pt-0 lg:mb-0.5 md:mt-1 lg:mt-0 mb-[7px] lg:mb-0" data-quick-atc data-is-available="${firstVariant ? firstVariant.available : true}" data-atc-id="${firstVariant ? firstVariant.id : ''}">
          <span class="quick-add-icon-xs md:hidden pr-0.5"></span>
          <span class="quick-add-icon hidden md:inline-block pr-1"></span>
          Quick Add
        </button>
      </div>
    `;

    return el;
  }

  async function injectForNode(node){
    if (!node || processed.has(node)) return;
    const handle = node.getAttribute && node.getAttribute('data-product-handle');
    if (!handle) return;
    // avoid injecting into structured-data elements
    if (node.querySelector && node.querySelector('quick-add')) { processed.add(node); return; }

    const product = await fetchProduct(handle);
    if (!product) { processed.add(node); return; }

    const qa = buildQuickAddElement(product);
    node.appendChild(qa);
    processed.add(node);
  }

  function scanAndInject(root=document){
    const nodes = root.querySelectorAll('[data-product-handle]');
    for (const n of nodes) injectForNode(n);
  }

  const observer = new MutationObserver((mutations)=>{
    for (const m of mutations){
      if (m.addedNodes && m.addedNodes.length){
        for (const n of m.addedNodes){
          if (n.nodeType !== 1) continue;
          if (n.hasAttribute && n.hasAttribute('data-product-handle')) injectForNode(n);
          else scanAndInject(n);
        }
      }
    }
  });

  document.addEventListener('DOMContentLoaded', ()=>{
    scanAndInject();
    observer.observe(document.body, { childList: true, subtree: true });
  });

})();
